import axiosInstance from '../axiosInstance';
import { toast } from 'sonner';

const API = 'employee-loans';

export const LOAN_ACTIONS = {
  FETCH_START: 'LOANS_FETCH_START',
  FETCH_SUCCESS: 'LOANS_FETCH_SUCCESS',
  FETCH_FAIL: 'LOANS_FETCH_FAIL',
  SET_SUMMARY: 'LOANS_SET_SUMMARY',
  ACTION_START: 'LOANS_ACTION_START',
  ACTION_END: 'LOANS_ACTION_END',
};

export const Fetch_Loans = (params = {}) => async (dispatch) => {
  dispatch({ type: LOAN_ACTIONS.FETCH_START });
  try {
    const { data } = await axiosInstance.get(API, { params });
    dispatch({ type: LOAN_ACTIONS.FETCH_SUCCESS, payload: data.data.loans });
  } catch (err) {
    dispatch({ type: LOAN_ACTIONS.FETCH_FAIL });
    toast.error(err.response?.data?.error || 'Failed to fetch loans');
  }
};

export const Fetch_Loan_Summary = (params = {}) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(`${API}/summary`, { params });
    dispatch({ type: LOAN_ACTIONS.SET_SUMMARY, payload: data.data });
  } catch (err) {}
};

export const Get_Loan_By_Id = (id) => async () => {
  try {
    const { data } = await axiosInstance.get(`${API}/${id}`);
    return data.data;
  } catch (err) {
    toast.error('Failed to fetch loan details');
    return null;
  }
};

export const Create_Loan = (loanData) => async (dispatch) => {
  dispatch({ type: LOAN_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.post(API, loanData);
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to create loan');
    throw err;
  }
};

export const Update_Loan = (id, loanData) => async (dispatch) => {
  dispatch({ type: LOAN_ACTIONS.ACTION_START });
  try {
    const { data } = await axiosInstance.put(`${API}/${id}`, loanData);
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    return data.data;
  } catch (err) {
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to update loan');
    throw err;
  }
};

export const Delete_Loan = (id) => async (dispatch) => {
  dispatch({ type: LOAN_ACTIONS.ACTION_START });
  try {
    await axiosInstance.delete(`${API}/${id}`);
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    return true;
  } catch (err) {
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to delete loan');
    return false;
  }
};

export const Add_Loan_Repayment = (loanId, repaymentData) => async (dispatch) => {
  dispatch({ type: LOAN_ACTIONS.ACTION_START });
  try {
    await axiosInstance.post(`${API}/${loanId}/repayments`, repaymentData);
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    return true;
  } catch (err) {
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to record payment');
    return false;
  }
};

export const Delete_Repayment = (loanId, repaymentId) => async (dispatch) => {
  dispatch({ type: LOAN_ACTIONS.ACTION_START });
  try {
    await axiosInstance.delete(`${API}/${loanId}/repayments/${repaymentId}`);
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    return true;
  } catch (err) {
    dispatch({ type: LOAN_ACTIONS.ACTION_END });
    toast.error(err.response?.data?.error || 'Failed to reverse payment');
    return false;
  }
};